import styled from "styled-components/macro";
import { smallElevationShadow, uiColors } from "../../../common/styles";
import { contentPaddingSides } from "../../../common/styles";

export const Logo = styled.img`
    cursor: pointer;
    max-width: unset;
`;

export const LeftWrapper = styled.section`
    display: flex;
    align-items: center;
    height: 100%;
    min-height: 50px;
    width: 90px;
    gap: 10px;
`;

export const RightWrapper = styled.section`
    display: flex;
    align-items: center;
    height: 100%;
    min-height: 50px;
    margin-right: ${(props) => props.$marginRight};

    & > svg {
        color: ${uiColors.PRIMARY};
    }
`;

export const NavbarSection = styled.section`
    position: ${(props) => props.$isMobile ? 'fixed' : 'absolute'};   
    width: 100%;
    height: 50px;
    top: 0;
    display: flex;
    margin-top: 0;
    justify-content: left;
    z-index: 1400;
    padding: 0 ${contentPaddingSides};
    box-shadow: 0 5px 5px rgba(0, 0, 0, 0.05);
    background: white;
    transition: transform 0.5s ease-in-out;
    align-items: center;
`;

export const CenterWrapper = styled.section`
    display: flex;
    flex-grow: 1;
    font-size: 20px;
    align-items: center;
    height: 100%;
    min-height: 50px;
    font-weight: 400;
    justify-content: center;
    margin-left: ${(props) => props.$marginLeft};
    text-align: center;
`;

export const SignedInAs = styled.section`
    display: flex;
    flex-direction: column;
    padding: 12px 17px;
`;

export const SignedInAsTopText = styled.span``;

export const SignedInAsEmail = styled.span`
    font-weight: bold;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export const AdditionalMenuContentWrapper = styled.div`
    border-bottom: 1px solid ${uiColors.GRAY_200}
`;

export const AdditionalMenuContentDescription = styled.p`
    font-size: 12px;
`;
